import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardBlocklistScreen() {
    const { Blocklist } = useModule(moderationDashModuleQuery);
    return <Blocklist />;
}
